import { useQuery } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";
import { useEndpoints } from "./useEndpoints";
import toast from "react-hot-toast";
import { ITeam } from "../models/Team";
import { queryClient } from "../constants/queryClient";
import { useState } from "react";

export const useDetailTeamPage = () => {
  const [currentTab, setCurrentTab] = useState("informations");

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const goBack = () => {
    const pathname = window.location.pathname;
    const newPath = pathname.match(/\/dashboard\/spaces\/[^/]+/)?.[0];

    navigate(newPath!, { replace: true });
  };
  const endpoints = useEndpoints();
  const params = useParams<{ id: string }>();
  const query = useQuery({
    queryKey: ["user", params.id],
    queryFn: async () => {
      const { data } = await endpoints.getTeam(params.id!);
      return data;
    },
  });


  const onClickStartIcon = async () => {
    setIsLoading(true);
    const toastId = toast.loading("Caricamento...");
    const team = query.data as ITeam;
    try {
      const isPreferred = !team.isPreferred;
      await endpoints.patchTeam(team._id, { isPreferred });
      queryClient.setQueryData(["user", params.id], (oldData: any) => {
        return {
          ...oldData,
          isPreferred,
        };
      });
      toast.success(
        isPreferred ? "Team aggiunto in evidenza" : "Team rimosso in evidenza",
        { id: toastId }
      );
    } catch (error) {
      console.error(error);
      toast.success("Errore", { id: toastId });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    onClickStartIcon,
    navigate,
    isLoading,
    currentTab,
    setCurrentTab,
    goBack,
    query,
  };
};
